import Graphs from "./Graphs";
export default Graphs;